<template>
  <div>
    <v-card flat>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="editedApplyFormIndex !== -1">
            <v-text-field label="單號" v-model="editedApplyForm.Number" disabled></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="editedApplyFormIndex !== -1">
            <v-text-field label="申請人" v-model="editedApplyForm.CreateBy" disabled></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="editedApplyFormIndex !== -1">
            <v-text-field label="狀態" v-model="turnInstallPositionStatus" disabled></v-text-field>
          </v-col>
        </v-row>
        <ValidationObserver ref="dialogEditedApplyForm">
          <v-row>
            <v-col>
              <ValidationProvider name="申請原因" rules="required" v-slot="{ errors }">
                <v-textarea
                  outlined
                  label="申請原因"
                  v-model="editedApplyForm.CreateReason"
                  :error-messages="errors[0]"
                  :disabled="isAllTextFieldDisable"
                >
                  <template v-slot:label>
                    <span class="red--text">
                      <strong>* </strong>
                    </span>
                    申請原因
                  </template>
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
        <v-row v-if="editedApplyForm.IsInvalid">
          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
            <v-text-field
              label="作廢人"
              v-model="editedApplyForm.InvalidBy"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
            <v-text-field label="作廢時間" v-model="turnInvalidTime" disabled></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="editedApplyForm.IsInvalid">
          <v-col>
            <v-textarea
              outlined
              label="作廢原因"
              v-model="editedApplyForm.InvalidReason"
              disabled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="installationPositionDataTableHeaders"
        :items="editedApplyForm.InstallPositionItems"
        class="elevation-1 my-5 mx-5"
        :search="searchInstallationPositionItems"
        :loading-text="$t('common_get_data')"
        :no-data-text="$t('common_no_data')"
        :no-results-text="$t('common_no_results')"
        :footer-props="{
          'items-per-page-options': [30, 50, 100],
          'items-per-page-text': $t('item_rows_per_page'),
        }"
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>安裝位置清單</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchInstallationPositionItems"
              append-icon="mdi-magnify"
              :label="$t('quotation_item_new_install_search')"
              single-line
              hide-details
              clearable
            ></v-text-field>
            <v-btn
              color="primary"
              class="ml-5"
              @click="isShowInstallPositionDialog = true"
              :disabled="isAllTextFieldDisable"
            >
              {{ $t('common_new') }}
            </v-btn>
            <v-dialog v-model="isShowInstallPositionDialog" max-width="800" persistent>
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                  <ValidationObserver ref="dialogEditedInstallPosition">
                    <v-row>
                      <v-col>
                        <ValidationProvider
                          name="安裝位置名稱"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedApplyFormItem.Name"
                            :error-messages="errors[0]"
                            :disabled="editedApplyFormItemIndex !== -1"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              安裝位置名稱
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <ValidationProvider name="定義" rules="required" v-slot="{ errors }">
                          <v-textarea
                            outlined
                            v-model="editedApplyFormItem.Description"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              定義
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" text @click="closeInstallPositionDialog">
                    {{ $t('common_cancel') }}
                  </v-btn>
                  <v-btn color="success" text @click="addInstallPosition">
                    {{ $t('common_confirm') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <delete-dialog
              :isAllTextFieldDisable="false"
              :isLoadingSaveBtn="false"
              :isShowDeleteDialog="isShowDeleteInstallPositionDialog"
              :deleteMessage="'common_delete'"
              @closeDelete="closeDeleteInstallPosition"
              @confirmDelete="confirmDeleteInstallPosition"
            />
          </v-toolbar>
        </template>
        <template v-slot:[`item.Edit`]="{ item }">
          <v-btn
            icon
            small
            :disabled="isAllTextFieldDisable"
            @click="isShowInstallPositionDialogBtn(item)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            :disabled="isAllTextFieldDisable"
            @click="isShowDeleteInstallPositionBtn(item)"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeApplyForm" :disabled="isLoading">
          {{ $t('common_cancel') }}
        </v-btn>
        <v-btn color="success" text @click="saveApplyForm" :disabled="isAllTextFieldDisable">
          {{ $t('common_save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import { InstallPositionStatus } from '@/js/InstallPositionStatus'
import { HttpInstallPosition } from '@/js/http-Manager'
export default {
  components: { DeleteDialog },
  props: {
    editedApplyFormIndex: {
      type: Number,
      default: -1
    },
    fatherEditedApplyForm: {
      type: Object
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  name: 'ApplyForm',
  data: () => ({
    editedApplyForm: {
      Number: '',
      CreateReason: '',
      Status: 0,
      CreateBy: '',
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      InstallPositionItems: []
    },
    defaultApplyForm: {
      Number: '',
      CreateReason: '',
      Status: 0,
      CreateBy: '',
      IsInvalid: false,
      InvalidBy: '',
      InvalidTime: 0,
      InvalidReason: '',
      InstallPositionItems: []
    },
    isShowInstallPositionDialog: false,
    searchInstallationPositionItems: '',
    editedApplyFormItem: {
      Name: '',
      Description: ''
    },
    defaultApplyFormItem: {
      Name: '',
      Description: ''
    },
    editedApplyFormItemIndex: -1,
    isShowDeleteInstallPositionDialog: false,
    installationPositionItems: []
  }),
  mounted () {
    this.setEditedApplyForm(this.fatherEditedApplyForm)
  },
  watch: {
    fatherEditedApplyForm (val) {
      this.setEditedApplyForm(val)
    }
  },
  computed: {
    installationPositionDataTableHeaders () {
      return [
        { text: '安裝位置', align: 'start', value: 'Name' },
        { text: '定義', align: 'start', value: 'Description' },
        { text: this.$t('common_edit'), align: 'start', value: 'Edit' }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnInstallPositionStatus () {
      return InstallPositionStatus.InstallPositionStatusName(this.editedApplyForm.Status)
    },
    turnInvalidTime () {
      return this.convertToDateTimeFormat(this.editedApplyForm.InvalidTime)
    }
  },
  methods: {
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installationPositionItems = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return ''
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setEditedApplyForm (val) {
      if (val) {
        this.editedApplyForm = JSON.parse(JSON.stringify(val))
      } else {
        this.editedApplyForm = JSON.parse(JSON.stringify(this.defaultApplyForm))
      }
    },
    closeApplyForm () {
      this.$emit('closeApplyForm')
    },
    async saveApplyForm () {
      if (this.editedApplyForm.InstallPositionItems.length === 0) {
        alert('請至少新增一個安裝位置')
      } else {
        const isValid = await this.$refs.dialogEditedApplyForm.validate()
        if (isValid) {
          this.$emit('setEditedApplyFormIndex', this.editedApplyFormIndex)
          this.$emit('saveEditedApplyForm', this.editedApplyForm)
          this.closeApplyForm()
        }
      }
    },
    closeInstallPositionDialog () {
      this.editedApplyFormItem = JSON.parse(JSON.stringify(this.defaultApplyFormItem))
      this.editedApplyFormItemIndex = -1
      this.isShowInstallPositionDialog = false
    },
    async addInstallPosition () {
      await this.getInstallPositionList()
      if (
        this.installationPositionItems.findIndex(
          (x) => x.Name === this.editedApplyFormItem.Name
        ) !== -1
      ) {
        alert('安裝位置清單已有')
      } else if (
        this.editedApplyForm.InstallPositionItems.findIndex(
          (x) => x.Name === this.editedApplyFormItem.Name
        ) !== -1
      ) {
        alert('安裝位置已重複')
      } else {
        const isValid = await this.$refs.dialogEditedInstallPosition.validate()
        if (isValid) {
          if (this.editedApplyFormItemIndex === -1) {
            this.editedApplyForm.InstallPositionItems.push(this.editedApplyFormItem)
          } else {
            this.editedApplyForm.InstallPositionItems.splice(
              this.editedApplyFormItemIndex,
              1,
              this.editedApplyFormItem
            )
          }
          this.closeInstallPositionDialog()
        }
      }
    },
    isShowInstallPositionDialogBtn (item) {
      this.editedApplyFormItem = JSON.parse(JSON.stringify(item))
      this.editedApplyFormItemIndex = this.editedApplyForm.InstallPositionItems.indexOf(item)
      this.isShowInstallPositionDialog = true
    },
    isShowDeleteInstallPositionBtn (item) {
      this.editedApplyFormItemIndex = this.editedApplyForm.InstallPositionItems.indexOf(item)
      this.isShowDeleteInstallPositionDialog = true
    },
    closeDeleteInstallPosition () {
      this.editedApplyFormItemIndex = -1
      this.isShowDeleteInstallPositionDialog = false
    },
    confirmDeleteInstallPosition () {
      this.editedApplyForm.InstallPositionItems.splice(this.editedApplyFormItemIndex, 1)
      this.closeDeleteInstallPosition()
    }
  }
}
</script>
